module.exports = __webpack_public_path__ + "static/media/orbitmi_logo.d0ba0cf6.svg";